module.exports = __webpack_public_path__ + "media/video.11fb919a.mp4";